import { render, staticRenderFns } from "./TableBrowse.vue?vue&type=template&id=83ba2064&"
import script from "./TableBrowse.vue?vue&type=script&lang=js&"
export * from "./TableBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports